import { render, staticRenderFns } from "./PayConsultation2.vue?vue&type=template&id=cd0d4a1a&scoped=true&"
import script from "./PayConsultation2.vue?vue&type=script&lang=js&"
export * from "./PayConsultation2.vue?vue&type=script&lang=js&"
import style0 from "./PayConsultation2.vue?vue&type=style&index=0&id=cd0d4a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0d4a1a",
  null
  
)

export default component.exports